import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getOrderGeneratorsFieldsWorksMaterials: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].GET_ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
	},
	getOrderGeneratorsFieldsWorksMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].GET_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL,
	},
	createOrderGeneratorsFieldsWorksMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL,
	},
	putOrderGeneratorsFieldsWorksMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].PUT_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL,
	},
	patchOrderGeneratorsFieldsWorksMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL,
	},
	deleteOrderGeneratorsFieldsWorksMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL,
	},
}
